let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bx03W")).then(() => parcelRequire('jwmy6'));